/**
 * Utility function to format lead names consistently across the application
 * @param {Object} lead - Lead object containing name fields
 * @returns {string} Formatted lead name
 */
export const formatLeadName = (lead) => {
  if (!lead) return "Unknown";
  
  // Priority order: FullName > FirstName + LastName > FirstName OR LastName > name > Unknown
  if (lead.FullName && lead.FullName.trim()) {
    return lead.FullName.trim();
  }
  
  if (lead.FirstName && lead.LastName) {
    return `${lead.FirstName.trim()} ${lead.LastName.trim()}`;
  }
  
  if (lead.FirstName && lead.FirstName.trim()) {
    return lead.FirstName.trim();
  }
  
  if (lead.LastName && lead.LastName.trim()) {
    return lead.LastName.trim();
  }
  
  if (lead.name && lead.name.trim()) {
    return lead.name.trim();
  }
  
  // For backward compatibility with follow-ups calendar data
  if (lead.leadname && lead.leadname.trim()) {
    return lead.leadname.trim();
  }
  
  if (lead.LeadName && lead.LeadName.trim()) {
    return lead.LeadName.trim();
  }
  
  if (lead.userName && lead.userName.trim()) {
    return lead.userName.trim();
  }
  
  return "Unknown";
};
